import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, string } from 'prop-types'
import { type FunctionComponent } from 'react'
import * as React from 'react'

type SellerInfoHeaderProps = {
  sellerName: string
  idx: number
  max: number
  disabled: boolean
  isMarketplacePromotion?: boolean
}

const SellerInfoHeader: FunctionComponent<SellerInfoHeaderProps> = ({
  sellerName,
  disabled,
  isMarketplacePromotion,
}): React.ReactElement => {
  const sellerInfoHeaderClassNames = classNames(
    'a-label l-flex l-flex__column',
    {
      'u-color--grey': disabled,
      'l-flex--start u-margin--bottom': !disabled,
    }
  )
  return (
    <div className={sellerInfoHeaderClassNames}>
      <div className="a-h3 u-no-margin">
        {isMarketplacePromotion ? (
          <Trans
            id="seller.promotion.shipping"
            values={{ seller: sellerName }}
          />
        ) : (
          <Trans
            id="voucher.details.modal.seller.info"
            values={{ 0: sellerName }}
          />
        )}
      </div>
      {!disabled && (
        <div className="u-color--grey u-font-weight--light">
          {isMarketplacePromotion ? (
            <Trans id="seller.promotion.discount.validFor" />
          ) : (
            <Trans id="voucher.details.modal.conditions" />
          )}
        </div>
      )}
    </div>
  )
}

SellerInfoHeader.propTypes = {
  sellerName: string.isRequired,
  // @ts-ignore
  disabled: bool,
}

SellerInfoHeader.defaultProps = {
  disabled: false,
  isMarketplacePromotion: false,
}

export default SellerInfoHeader
